import { useExperimentTracking } from "@/src/experiments/useExperimentTracking";
import { croWeb168Config } from "./config";
import {
  ExperimentVariant,
  getCroWeb168VariantFromFeatureFlag,
} from "./getCroWeb168Variant";

// Removed global override functionality - using PostHog toolbar instead

/**
 * Hook for CRO-WEB-168 experiment
 * Returns the variant and whether subscription cards should be shown
 */
export const useCroWeb168Experiment = () => {
  // Track experiment participation
  useExperimentTracking(croWeb168Config);

  // Get variant from PostHog feature flag
  const variant = getCroWeb168VariantFromFeatureFlag() || "hidden";

  return {
    variant,
    shouldShowSubscriptionCards: variant !== "hidden",
  };
};
